export default "__VITE_ASSET__CJdWQ0El__"